import * as React from 'react';
import {StyleProp, StyleSheet, View, ViewStyle} from 'react-native';

import NewBackgroundUsageHistoryButton from './NewBackgroundUsageHistoryButton';

interface Props {
  style?: StyleProp<ViewStyle>;
  onPress: () => void;
}

const BottomNewBackgroundUsageHistoryButton: React.FunctionComponent<
  Props
> = props => {
  const {style, onPress} = props;
  return (
    <View style={[styles.container, style]}>
      <NewBackgroundUsageHistoryButton onPress={onPress} />
    </View>
  );
};

export default React.memo(BottomNewBackgroundUsageHistoryButton);

const styles = StyleSheet.create({
  container: {
    left: 0,
    right: 0,
    position: 'absolute',
    bottom: 16,
    alignItems: 'center',
  } as ViewStyle,
});
